export enum PaymentStatus {
  PAID = 'Paid',
  PENDING_PAYMENT = 'Pending payment',
  NA = 'N/A',
}
